export default {
    bloglist: {
        en: [
            {
                title: 'How to Change Themes in GB WhatsApp',
                poster: require('@/assets/blog-cover-themes.webp'),
                desc: 'Learn how to change themes in GB WhatsApp, customize chat colors and backgrounds, apply supported theme files, and restore the default look.',
                name: 'en-blog-themes',
                url: '/change-gb-whatsapp-themes/',
                date: '2026-10-23',
            },
            {
                title: 'How to Change Call Privacy Settings in GB WhatsApp',
                poster: require('@/assets/blog-cover-call-privacy-gbmodshub.jpg'),
                desc: 'Learn how to check GB WhatsApp call privacy settings, manage available call controls, troubleshoot missing options, and reduce unwanted interruptions.',
                name: 'en-blog-call-privacy',
                url: '/change-call-privacy-settings-gb-whatsapp/',
                date: '2026-10-23',
            },
        ],
    }
    
}